// Mock data for VIAL RAT RESEARCH CO. clone

import { productExtras } from './productExtras';

export const products = [
  {
    slug: '5-amino-1mq-50mg',
    name: '5-Amino-1MQ',
    dose: '50 mg',
    price: 95,
    priceDisplay: '$95.00',
    stock: 10,
    category: 'Research Compounds',
    image: 'https://customer-assets-jai6qajn.emergentagent.net/job_lab-rat-research/artifacts/yjcmxj46_B1D3FAA2-5FFF-457F-B679-BF5E9D3CF10D.png',
    tagline: 'Research Compound | Research Use Only',
    description: '5-Amino-1MQ is a small-molecule research compound being investigated for its interaction with the NNMT enzyme and its potential role in cellular energy metabolism.',
    overview: {
      code: '5-AM \u2014 5-Amino-1MQ',
      subtitle: 'METABOLIC & BODY COMPOSITION RESEARCH',
      intro: '5-Amino-1MQ (5-AM) is a small-molecule research compound studied for its ability to inhibit NNMT, an enzyme involved in cellular energy and metabolic processes.',
      leadIn: 'Research interest in 5-AM focuses on its potential role in:',
      bullets: [
        { icon: 'Flame', title: 'Fat Metabolism', text: 'studied for effects on how fat cells store and utilize energy' },
        { icon: 'Zap', title: 'Metabolic Activity', text: 'investigated for its influence on cellular energy expenditure' },
        { icon: 'Dna', title: 'NAD+ Pathways', text: 'researched for its relationship with NAD+ and cellular energy metabolism' },
        { icon: 'Target', title: 'Body Composition', text: 'studied in preclinical models for potential effects on fat mass' },
        { icon: 'Activity', title: 'Metabolic Health', text: 'investigated in research involving glucose and metabolic regulation' }
      ],
      highlight: {
        label: 'HOW IT\u2019S DIFFERENT',
        text: 'Unlike GLP-1\u2013based compounds, 5-AM research primarily focuses on cellular metabolism and NNMT inhibition rather than appetite suppression.'
      },
      note: 'Important: 5-Amino-1MQ is technically a small molecule, not a peptide, despite commonly being grouped with research peptides.',
      disclaimer: 'FOR RESEARCH USE ONLY \u2014 NOT FOR HUMAN CONSUMPTION'
    },
    storage: 'Store cool, dry and away from direct light. Keep sealed until use.',
    research: ['Cellular Energy Metabolism', 'NNMT Pathway Research', 'Adipose Tissue Studies'],
    protocol: {
      title: '5-Amino-1MQ Dosage Chart',
      intro: '5-Amino-1MQ is dosed at 2.5 mg\u20135 mg daily via subcutaneous injection in educational protocols. A 10 mg vial reconstituted with bacteriostatic water yields about 5 mg/mL. This information is for research and educational use only.',
      bullets: [
        { label: 'Reconstitute', text: 'Add 2.0 mL bacteriostatic water \u2192 5 mg/mL concentration.' },
        { label: 'Typical daily range', text: '2.5\u20135 mg once or twice daily (subcutaneous).' },
        { label: 'Easy measuring', text: 'At 5 mg/mL, 1 unit = 0.01 mL = 50 mcg (0.05 mg) on a U-100 insulin syringe.' },
        { label: 'Storage', text: 'Lyophilized: freeze at \u221220 \u00b0C (\u22124 \u00b0F); after reconstitution, refrigerate at 2\u20138 \u00b0C (35.6\u201346.4 \u00b0F) and use within 2\u20134 weeks.' }
      ],
      notes: '5-Amino-1MQ dosage protocols center on this selective, cell-permeable NNMT (Nicotinamide N-methyltransferase) inhibitor studied for its potential to support fat metabolism, preserve lean muscle mass, and elevate intracellular NAD+ levels. By blocking NNMT, 5-Amino-1MQ may help restore cellular energy balance and activate SIRT1 pathways associated with metabolic efficiency. This educational protocol presents a subcutaneous injection approach to maximize bioavailability from the 10 mg vial format.'
    }
  },
  {
    slug: 'bpc-157-10mg',
    name: 'BPC-157',
    dose: '10 mg',
    price: 70,
    priceDisplay: '$70.00',
    stock: 10,
    category: 'Research Peptides',
    image: 'https://customer-assets-jai6qajn.emergentagent.net/job_lab-rat-research/artifacts/0r3pl9tu_17B33F93-8D5B-4B5A-90EE-5A5BC365D7D3.png',
    tagline: 'Body Protection Compound | Research Use Only',
    description: 'BPC-157 is a synthetic pentadecapeptide derived from a naturally occurring gastric protein. It is widely studied in tissue repair and gut integrity research.',
    storage: 'Store lyophilized vials refrigerated. Once reconstituted, keep at 2-8°C, away from light.',
    research: ['Tissue Repair', 'Gut Integrity', 'Tendon & Ligament Research', 'Anti-Inflammatory Pathways']
  },
  {
    slug: 'ghk-cu',
    name: 'GHK-Cu',
    dose: '50 mg / 100 mg',
    price: 60,
    priceDisplay: '$60.00 \u2013 $100.00',
    stock: 20,
    category: 'Research Peptides',
    image: 'https://customer-assets-jai6qajn.emergentagent.net/job_lab-rat-research/artifacts/y8gcjiim_E95922CA-DC4F-42F2-86D8-EB00808C0E66.png',
    tagline: 'Copper Peptide Complex | Research Use Only',
    description: 'GHK-Cu (Copper Tripeptide-1) is a naturally occurring copper-binding tripeptide composed of glycine, histidine and lysine. It is found naturally in human plasma and has been extensively investigated for its involvement in tissue remodeling and skin biology.',
    storage: 'Store lyophilized vials refrigerated; unopened powder may be frozen for long-term storage. Once reconstituted, keep refrigerated at 2-8\u00b0C, away from direct light.',
    research: ['Skin & Collagen Research', 'Tissue Repair & Remodeling', 'Healthy-Aging Research', 'Antioxidant & Inflammatory Signaling', 'Hair & Follicle Research'],
    variants: [
      { label: '50 mg', price: 60, priceDisplay: '$60.00', stock: 20 },
      { label: '100 mg', price: 100, priceDisplay: '$100.00', stock: 20 }
    ]
  },
  {
    slug: 'klow-blend-80mg',
    name: 'KLOW Blend',
    dose: '80 mg',
    price: 110,
    priceDisplay: '$110.00',
    stock: 10,
    category: 'Blends',
    image: 'https://customer-assets-jai6qajn.emergentagent.net/job_lab-rat-research/artifacts/uh7utyuv_806B4C8F-4194-44D8-BCED-9CC4544C4495.png',
    tagline: 'Research Blend | KPV + BPC-157 + TB-500 + GHK-Cu',
    description: 'KLOW Blend combines four research peptides — KPV, BPC-157, TB-500, and GHK-Cu — commonly investigated together in tissue and cellular repair research.',
    storage: 'Store lyophilized vials refrigerated. Once reconstituted, keep at 2-8°C, away from direct light.',
    research: ['Combined Tissue Research', 'Inflammatory Pathway Research', 'Skin & Collagen Research']
  },
  {
    slug: 'melanotan-ii-10mg',
    name: 'Melanotan II',
    dose: '10 mg',
    price: 50,
    priceDisplay: '$50.00',
    stock: 10,
    category: 'Research Peptides',
    image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_lab-rat-study/artifacts/kuh8588q_189DCB4A-8D78-4EEF-A2C0-8359BECAD3D4.png',
    tagline: 'Melanocortin Analog | Research Use Only',
    description: 'Melanotan II is a synthetic analog of alpha-melanocyte stimulating hormone (α-MSH) investigated for its role in melanocortin receptor signaling.',
    storage: 'Store lyophilized refrigerated. Reconstituted vials keep at 2-8°C.',
    research: ['Melanocortin Signaling', 'Pigmentation Research', 'Receptor Biology']
  },
  {
    slug: 'melanotan-i-10mg',
    name: 'Melanotan I (MT-1)',
    dose: '10 mg',
    price: 45,
    priceDisplay: '$45.00',
    stock: 0,
    category: 'Research Peptides',
    image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_lab-rat-study/artifacts/t9zvg8gn_77B15C7A-BF7F-4117-8DB1-43F109F7A92E.png',
    tagline: 'Follow the Melanin Signal | Research Use Only',
    description: 'Melanotan I is a synthetic analogue of \u03b1-melanocyte-stimulating hormone (\u03b1-MSH), a naturally occurring peptide involved in melanocortin signalling.\n\nIt has been researched primarily for its interaction with the melanocortin-1 receptor (MC1R) and the biological pathways controlling melanin production and pigmentation.',
    storage: 'Store lyophilized vials refrigerated. Once reconstituted, keep at 2\u20138 \u00b0C, away from direct light.',
    research: [
      { title: 'Pigmentation Research', text: 'Activation of MC1R on melanocytes can stimulate melanogenesis \u2014 the biological process responsible for producing melanin.' },
      { title: 'MC1R Signalling', text: 'MT-1 is particularly interesting because its activity is associated strongly with MC1R, making melanocortin receptor signalling a central area of research.' },
      { title: '\u03b1-MSH Analogue', text: 'MT-1 was developed from the naturally occurring \u03b1-MSH signalling system, but modifications to the peptide make it more stable and longer-lasting than endogenous \u03b1-MSH.' },
      { title: 'Melanocyte Biology', text: 'Research involving MT-1 and related melanocortin compounds has explored melanocyte activity, pigmentation pathways and responses to ultraviolet exposure.' },
      { title: 'MT-1 vs MT-2', text: 'They\u2019re related, but not interchangeable. MT-1 \u2192 predominantly pigmentation / MC1R research. MT-2 \u2192 broader melanocortin-receptor activity, which is why research and grey-market discussion around MT-2 also involves appetite and sexual-function effects.' }
    ],
    researchStatus: 'Research Note \u2014 Afamelanotide is closely related to the compound commonly referred to as Melanotan I. However, research material labelled MT-1 should not be represented as the approved afamelanotide medicine Scenesse.\n\nFOR RESEARCH USE ONLY \u2014 NOT FOR HUMAN OR VETERINARY CONSUMPTION.',
    preorder: true
  },
  {
    slug: 'mots-c-20mg',
    name: 'MOTS-c',
    dose: '20 mg / 30 mg',
    price: 85,
    priceDisplay: '$85.00',
    stock: 10,
    category: 'Research Peptides',
    image: 'https://customer-assets-jai6qajn.emergentagent.net/job_lab-rat-research/artifacts/sa92ktny_3356F8E4-3866-4D5E-BC5F-34576F8E9F21.png',
    tagline: 'Mitochondrial-Derived Peptide | Research Use Only',
    description: 'MOTS-c is a 16-amino-acid mitochondrial-derived peptide investigated for its potential role in metabolic regulation and cellular energy homeostasis.',
    storage: 'Store lyophilized refrigerated. Reconstituted vials keep at 2-8°C.',
    research: ['Mitochondrial Research', 'Metabolic Regulation', 'Cellular Energy Homeostasis'],
    variants: [
      { label: '20 mg', price: 85, priceDisplay: '$85.00' },
      { label: '30 mg', price: null, priceDisplay: 'OUT OF STOCK', outOfStock: true }
    ]
  },
  {
    slug: 'nad-plus-500mg',
    name: 'NAD+',
    dose: '500 mg',
    price: 85,
    priceDisplay: '$85.00',
    stock: 10,
    category: 'Research Compounds',
    image: 'https://customer-assets-jai6qajn.emergentagent.net/job_lab-rat-research/artifacts/lzsj038i_96343FFB-4A32-4862-9437-F36C8D299C7B.png',
    tagline: 'Nicotinamide Adenine Dinucleotide | Research Use Only',
    description: 'NAD+ is a coenzyme central to metabolism and cellular energy production. Widely studied in aging, mitochondrial biology, and metabolic pathway research.',
    storage: 'Store lyophilized refrigerated. Reconstituted vials keep at 2-8°C, away from light.',
    research: ['Cellular Energy Research', 'Anti-Aging Research', 'Metabolic Health', 'Mitochondrial Function']
  },
  {
    slug: 'retatrutide',
    name: 'Retatrutide',
    dose: '10 mg / 20 mg / 30 mg',
    price: 100,
    priceDisplay: '$100.00 – $175.00',
    stock: 10,
    category: 'Research Peptides',
    image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_lab-rat-study/artifacts/p3k8rdsv_545FE7A6-E91D-486B-9D48-0D2E7E732416.png',
    tagline: 'Triple-Receptor Agonist | Research Use Only',
    description: 'Retatrutide is an investigational peptide being studied for its activity at three metabolic hormone receptors: GLP-1, GIP and glucagon receptors. This triple-agonist mechanism is what distinguishes retatrutide from compounds that target only one or two of these pathways.\n\nWHY RETATRUTIDE IS DIFFERENT\nMany incretin-based compounds act on one or two receptors. Retatrutide simultaneously targets: GLP-1 + GIP + GLUCAGON. Researchers are studying whether this three-pathway approach can produce broader metabolic effects than single- or dual-receptor agonism.',
    storage: 'Store lyophilized vials refrigerated; unopened powder may be frozen for long-term storage. Bring the sealed vial to room temperature before opening. Once reconstituted, keep refrigerated at 2-8\u00b0C (36-46\u00b0F), away from direct light.',
    research: [
      { title: 'Body-weight regulation', text: 'Clinical research has demonstrated substantial reductions in body weight in study participants.' },
      { title: 'Appetite and food intake', text: 'GLP-1 and GIP pathways are involved in appetite, satiety and metabolic signaling.' },
      { title: 'Energy expenditure', text: 'Activation of the glucagon receptor is being investigated for its potential influence on energy expenditure and fat metabolism.' },
      { title: 'Glucose metabolism', text: 'Researchers are studying its effects on insulin sensitivity, glucose regulation and other metabolic markers.' },
      { title: 'Cardiometabolic health', text: 'Studies are examining changes in factors such as waist circumference, blood lipids and other metabolic measurements.' }
    ],
    researchStatus: 'Retatrutide is an investigational compound and is still undergoing clinical research. It is not approved by Health Canada or the FDA for routine medical use.\n\nFOR RESEARCH USE ONLY \u2014 NOT FOR HUMAN CONSUMPTION. This information is provided for educational and research-reference purposes and is not medical advice or a recommendation for use.',
    variants: [
      { label: '10 mg', price: 100, priceDisplay: '$100.00', stock: 0, preorder: true },
      { label: '20 mg', price: 135, priceDisplay: '$135.00', stock: 10 },
      { label: '30 mg', price: 175, priceDisplay: '$175.00', stock: 0, preorder: true }
    ]
  },
  {
    slug: 'selank-10mg',
    name: 'Selank',
    dose: '10 mg',
    price: 60,
    priceDisplay: '$60.00',
    stock: 10,
    category: 'Research Peptides',
    image: 'https://customer-assets-jai6qajn.emergentagent.net/job_lab-rat-research/artifacts/7kaz7b2q_9E3E99D2-32F8-44AB-8BAE-08ED6EE7C3F2.png',
    tagline: 'Nootropic Research Peptide | Research Use Only',
    description: 'Selank is a synthetic heptapeptide investigated for its interaction with pathways associated with anxiety, memory and immune modulation.',
    storage: 'Store lyophilized refrigerated. Reconstituted vials keep at 2-8°C.',
    research: ['Anxiolytic Research', 'Nootropic Studies', 'Immune Modulation']
  },
  {
    slug: 'semax-10mg',
    name: 'Semax',
    dose: '10 mg',
    price: 60,
    priceDisplay: '$60.00',
    stock: 10,
    category: 'Research Peptides',
    image: 'https://customer-assets-jai6qajn.emergentagent.net/job_lab-rat-research/artifacts/hc2zchal_6C764B4F-FA06-49C2-934A-44E1AA3E6089.png',
    tagline: 'Nootropic Research Peptide | Research Use Only',
    description: 'Semax is a synthetic peptide analog of ACTH(4-10) investigated for its neuroprotective and cognitive research applications.',
    storage: 'Store lyophilized refrigerated. Reconstituted vials keep at 2-8°C.',
    research: ['Neuroprotective Research', 'Cognitive Studies', 'BDNF Pathway Research']
  },
  {
    slug: 'tesamorelin-10mg',
    name: 'Tesamorelin',
    dose: '10 mg / 20 mg',
    price: 110,
    priceDisplay: '$110.00',
    stock: 10,
    category: 'Research Peptides',
    image: 'https://static.prod-images.emergentagent.com/jobs/b6d9efba-b5a6-4827-a8fc-40656bb19f7f/images/4c1caaf2c33854033770efe3d09822df2b1b08452da14a849497a2780edc327b.jpeg',
    tagline: 'Growth Hormone Releasing Analog | Research Use Only',
    description: 'Tesamorelin is a synthetic analog of growth hormone-releasing hormone (GHRH) investigated in metabolic and endocrine research.',
    storage: 'Store lyophilized refrigerated. Reconstituted vials keep at 2-8°C.',
    research: ['GHRH Pathway Research', 'Metabolic Studies', 'Endocrine Research'],
    variants: [
      { label: '10 mg', price: 110, priceDisplay: '$110.00', stock: 10 },
      { label: '20 mg', price: 160, priceDisplay: '$160.00', stock: 0, preorder: true }
    ]
  },
  {
    slug: 'wolverine-blend-20mg',
    name: 'Wolverine Blend',
    dose: '20 mg (BPC-157 10 mg + TB-500 10 mg)',
    price: 100,
    priceDisplay: '$100.00',
    stock: 10,
    category: 'Blends',
    image: 'https://customer-assets-jai6qajn.emergentagent.net/job_lab-rat-research/artifacts/5uryjjan_32A28987-7FA5-46D0-B414-4235F699097D.png',
    tagline: 'Tissue Repair Research Blend | Research Use Only',
    description: 'Wolverine Blend combines BPC-157 and TB-500 — two peptides commonly investigated together in tissue repair and recovery research.',
    storage: 'Store lyophilized refrigerated. Reconstituted vials keep at 2-8°C.',
    research: ['Tissue Repair', 'Recovery Research', 'Anti-Inflammatory Pathways']
  },
  // ===== NEW PRODUCT PLACEHOLDERS (info, pricing, images pending) =====
  {
    slug: 'cjc-ipa-stack',
    name: 'CJC-1295 No DAC + Ipamorelin',
    dose: '10 mg + 10 mg (stack pack)',
    price: 70,
    priceDisplay: '$70.00',
    stock: 10,
    category: 'Blends',
    image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_lab-rat-study/artifacts/9g8lqnt0_93E7EC86-9129-461E-A6E0-D096F5EEDA07.png',
    tagline: 'The Ultimate GH Pulse Stack | Research Use Only',
    description: 'CJC-1295 No DAC + Ipamorelin combines two research peptides that influence growth hormone (GH) release through different pathways. CJC-1295 No DAC is a GHRH analog, while Ipamorelin is a growth hormone secretagogue that activates the ghrelin/GHSR-1a receptor. Together, they are researched for their complementary effects on the body\u2019s natural growth-hormone signalling.',
    preorder: true
  },
  {
    slug: 'glutathione-600mg',
    name: 'Glutathione',
    dose: '600 mg / 1500 mg',
    price: 60,
    priceDisplay: '$60.00',
    stock: 10,
    category: 'Research Compounds',
    image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_lab-rat-study/artifacts/18lbg9mf_905B81E5-3F4F-432F-8A2D-EB390A99C10C.png',
    preorder: true,
    tagline: 'Coming Soon | Research Use Only',
    description: 'Product details, pricing, imagery and research information for Glutathione will be added in a later update.',
    variants: [
      { label: '600 mg', price: 60, priceDisplay: '$60.00', stock: 0, preorder: true },
      { label: '1500 mg', price: 100, priceDisplay: '$100.00', stock: 0, preorder: true }
    ]
  },
  {
    slug: 'kpv-10mg',
    name: 'KPV',
    dose: '10 mg',
    price: 65,
    priceDisplay: '$65.00',
    stock: 10,
    category: 'Research Peptides',
    image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_lab-rat-study/artifacts/k2qsfger_5451A2B5-8485-4076-A170-FE91E5831C0F.png',
    preorder: true,
    tagline: 'Coming Soon | Research Use Only',
    description: 'Product details, pricing, imagery and research information for KPV will be added in a later update.'
  },
  {
    slug: 'pt-141-10mg',
    name: 'PT-141',
    dose: '10 mg',
    price: 70,
    priceDisplay: '$70.00',
    stock: 10,
    category: 'Research Peptides',
    image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_lab-rat-study/artifacts/qv9k5xyf_B5E164FD-C0D2-46D0-8444-044D814F072B.png',
    preorder: true,
    tagline: 'Coming Soon | Research Use Only',
    description: 'Product details, pricing, imagery and research information for PT-141 will be added in a later update.'
  },
  {
    slug: 'ipamorelin',
    name: 'Ipamorelin',
    dose: '10 mg',
    price: 70,
    priceDisplay: '$70.00',
    stock: 10,
    category: 'Research Peptides',
    image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_lab-rat-study/artifacts/f31syy7a_9146020E-7BB6-4D32-9CD4-6E165B1E485C.png',
    preorder: true,
    tagline: 'Coming Soon | Research Use Only',
    description: 'Product details, pricing, imagery and research information for Ipamorelin will be added in a later update.'
  },
  {
    slug: 'cjc-1295-no-dac',
    name: 'CJC-1295 No DAC',
    dose: '10 mg',
    price: 70,
    priceDisplay: '$70.00',
    stock: 10,
    category: 'Research Peptides',
    image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_lab-rat-study/artifacts/uxhglalp_BA116C48-2429-492E-8311-B0A447EC8B7C.png',
    preorder: true,
    tagline: 'Coming Soon | Research Use Only',
    description: 'Product details, pricing, imagery and research information for CJC-1295 No DAC will be added in a later update.'
  },
  {
    slug: 'snap-8',
    name: 'SNAP-8',
    dose: '10 mg',
    price: 60,
    priceDisplay: '$60.00',
    stock: 10,
    category: 'Research Peptides',
    image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_lab-rat-study/artifacts/jvg8pxoa_97386002-1B9F-4054-9A47-0308023EFEF3.png',
    tagline: 'Cosmetic Peptide Research | Acetyl Octapeptide-3 | Topical Research Use Only',
    description: 'SNAP-8 (Acetyl Octapeptide-3) is a synthetic cosmetic peptide developed for research into the appearance of fine lines and expression wrinkles. Sometimes nicknamed a "Botox-like" cosmetic peptide, SNAP-8 is studied for its potential interaction with pathways involved in facial muscle contraction. Unlike Botox, however, SNAP-8 is primarily researched as a topical cosmetic ingredient and should not be presented as equivalent to injectable botulinum toxin.',
    storage: 'Store lyophilized vials refrigerated; unopened powder may be frozen for long-term storage. Once reconstituted or formulated into a topical vehicle, refrigerate at 2\u20138 \u00b0C and use within the timeframe recommended for the chosen formulation.',
    preorder: true,
    research: [
      { title: 'Fine lines & wrinkles', text: 'Studied for the appearance of expression-related lines.' },
      { title: 'Crow\u2019s-feet', text: 'Around-the-eye area is a common cosmetic research target.' },
      { title: 'Forehead & expression lines', text: 'Areas influenced by repetitive facial movement.' },
      { title: 'Smoother-looking skin', text: 'Researched in topical cosmetic formulations.' },
      { title: 'Anti-aging serums & creams', text: 'Commonly incorporated into multi-ingredient cosmetic research formulations.' }
    ],
    overview: {
      code: 'SNAP-8 \u2014 10 mg',
      subtitle: 'COSMETIC PEPTIDE RESEARCH',
      intro: 'SNAP-8 is an eight-amino-acid peptide related to the SNAP-25 / SNARE pathway involved in neurotransmitter release and muscle contraction. The theory behind SNAP-8 is that interfering with this signaling pathway may help reduce the appearance of expression-related wrinkles. While promising cosmetic research exists, evidence for SNAP-8 used by itself remains limited, and many human studies have tested it as part of multi-ingredient formulations.',
      leadIn: 'Why SNAP-8 shows up in cosmetic peptide research:',
      bullets: [
        { icon: 'Sparkles', title: 'Expression lines', text: 'Fine lines and wrinkles from repetitive facial movement.' },
        { icon: 'Eye', title: 'Crow\u2019s-feet', text: 'Around the eyes where dynamic wrinkles form.' },
        { icon: 'Zap', title: 'Forehead lines', text: 'Common focus for cosmetic peptide serums.' },
        { icon: 'Droplet', title: 'Smoother-looking skin', text: 'Studied for texture in topical formulations.' },
        { icon: 'Activity', title: 'Anti-aging routines', text: 'Frequently paired with other cosmetic peptides in research.' }
      ],
      highlight: {
        label: 'HOW IT DIFFERS FROM BOTOX',
        text: 'SNAP-8 is a synthetic cosmetic peptide researched primarily as a topical ingredient. It should NOT be presented as equivalent to injectable botulinum toxin.'
      },
      note: 'Vial Rat Research Note: SNAP-8 is an interesting addition to cosmetic peptide research, particularly for anyone exploring peptides associated with skin aging, expression lines and smoother-looking skin.',
      disclaimer: 'FOR RESEARCH USE ONLY \u2014 NOT INTENDED FOR INJECTION OR HUMAN CONSUMPTION'
    }
  },
  {
    slug: 'dsip',
    name: 'DSIP',
    dose: '10 mg',
    price: 45,
    priceDisplay: '$45.00',
    stock: 10,
    category: 'Research Peptides',
    image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_lab-rat-study/artifacts/3czf3sc8_70CC996D-8BA1-4407-8CBD-111C9FD22FDA.png',
    tagline: 'Coming Soon | Research Use Only',
    description: 'Product details, pricing, imagery and research information for DSIP will be added in a later update.',
    preorder: true
  },
  {
    slug: 'glow-70mg',
    name: 'GLOW',
    dose: '70 mg (GHK-Cu 50 mg + BPC-157 10 mg + TB-500 10 mg)',
    price: 100,
    priceDisplay: '$100.00',
    stock: 10,
    category: 'Blends',
    image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_lab-rat-study/artifacts/abkt6sdr_CC4E9003-708F-4DDF-A58B-73D9DDC1FD8D.png',
    tagline: 'Coming Soon | Research Blend',
    description: 'GLOW is a research blend containing GHK-Cu 50 mg + BPC-157 10 mg + TB-500 10 mg (total 70 mg). Full product details, pricing, imagery and research information will be added in a later update. Note: GLOW does not contain KPV.',
    preorder: true
  },
  {
    slug: 'ss-31',
    name: 'SS-31',
    dose: '10 mg',
    price: 70,
    priceDisplay: '$70.00',
    stock: 10,
    category: 'Research Peptides',
    image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_lab-rat-study/artifacts/5umyuizz_42840A59-2252-4C09-913A-B6691334CC1D.png',
    tagline: 'Coming Soon | Research Use Only',
    description: 'Product details, pricing, imagery and research information for SS-31 will be added in a later update.',
    preorder: true
  },
  {
    slug: 'epithalon-10mg',
    name: 'Epithalon',
    dose: '10 mg',
    price: 45,
    priceDisplay: '$45.00',
    stock: 0,
    category: 'Research Peptides',
    image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_lab-rat-study/artifacts/8etyjzpr_BE336A2D-056C-47C4-B118-4DEBE91E110B.png',
    tagline: 'Researching the Biology of Aging | Research Use Only',
    description: 'Epithalon (also spelled Epitalon) is a synthetic tetrapeptide modeled after epithalamin, a peptide preparation associated with pineal-gland research.\n\nWhat makes Epithalon unusual is the research surrounding cellular aging, circadian biology and telomere/telomerase mechanisms. Much of the published work comes from Russian research groups, and the evidence in humans remains limited — so these areas should remain firmly within the research context rather than being presented as established anti-aging effects.',
    storage: 'Store lyophilized vials refrigerated. Once reconstituted, keep at 2\u20138 \u00b0C, away from direct light.',
    research: [
      { title: 'Cellular Aging Research', text: 'Studied experimentally in connection with cellular aging and longevity-associated biological pathways.' },
      { title: 'Telomere & Telomerase Research', text: 'Epithalon has been investigated in laboratory models for potential effects involving telomerase activity and telomere biology.' },
      { title: 'Circadian & Pineal Research', text: 'Its origins in pineal-peptide research have led to investigation of circadian rhythms, melatonin-associated pathways and age-related changes in biological rhythms.' },
      { title: 'Longevity Research', text: 'Experimental studies have explored Epithalon in relation to lifespan and age-associated biological processes, although these findings should not be interpreted as evidence that it extends human lifespan.' }
    ],
    researchStatus: 'Vial Rat Research Note — tiny peptide, big research question. Epithalon contains only four amino acids (Ala-Glu-Asp-Gly / AEDG), making it one of the smallest peptides in the Vial Rat lineup.\n\nFOR RESEARCH USE ONLY — Not for human or veterinary use / consumption.',
    preorder: true
  },
  {
    slug: 'kisspeptin-10',
    name: 'Kisspeptin-10',
    dose: '10 mg',
    price: 67,
    priceDisplay: '$67.00',
    stock: 0,
    category: 'Research Peptides',
    image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_lab-rat-study/artifacts/jyqpu2b1_4FC25716-8372-43E2-AE81-9430014320B5.png',
    tagline: 'The Signal Behind the Signal | Research Use Only',
    description: 'Kisspeptin-10 is a short peptide fragment derived from kisspeptin, a naturally occurring signalling molecule with an important role in the hypothalamic\u2013pituitary\u2013gonadal (HPG) axis.\n\nRather than being a reproductive hormone itself, kisspeptin acts further upstream — making it particularly interesting for research into how the brain communicates with the reproductive endocrine system.',
    storage: 'Store lyophilized vials refrigerated. Once reconstituted, keep at 2\u20138 \u00b0C, away from direct light.',
    research: [
      { title: 'Hypothalamic Signalling', text: 'Kisspeptin activates the KISS1 receptor (KISS1R) and is an important regulator of neurons responsible for releasing gonadotropin-releasing hormone (GnRH).' },
      { title: 'Reproductive Endocrinology', text: 'Through its relationship with GnRH signalling, kisspeptin has been extensively investigated in research involving LH and FSH secretion, reproductive physiology and fertility.' },
      { title: 'Hormone-Signal Research', text: 'Part of a signalling cascade: Kisspeptin \u2192 GnRH \u2192 LH / FSH \u2192 Gonadal signalling. That upstream position is one of the reasons kisspeptin attracts so much endocrine research interest.' },
      { title: 'Sexual & Behavioural Research', text: 'Human neuroimaging and experimental studies have also investigated kisspeptin in relation to sexual and emotional brain processing, although that research shouldn\u2019t be interpreted as establishing it as a libido treatment.' },
      { title: 'Kisspeptin-10 Fragment', text: 'Kisspeptin exists in several biologically active forms. Kisspeptin-10 is the shorter 10-amino-acid fragment that retains activity at KISS1R and is commonly used in experimental research.' }
    ],
    researchStatus: 'Vial Rat Science — start at the source. Format: Lyophilized research material.\n\nFOR RESEARCH USE ONLY \u2014 NOT FOR HUMAN OR VETERINARY CONSUMPTION.',
    preorder: true
  },
  {
    slug: 'ahk-cu-100mg',
    name: 'AHK-Cu',
    dose: '100 mg',
    price: 110,
    priceDisplay: '$110.00',
    stock: 0,
    category: 'Research Peptides',
    image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_lab-rat-study/artifacts/uvexz8cb_B4A44E1F-EE70-4585-BEFC-378FBCC7C9E4.png',
    tagline: 'Copper Peptide Research | Research Use Only',
    description: 'AHK-Cu is a naturally occurring copper-binding tripeptide complex studied primarily in relation to hair-follicle biology, skin biology and cellular signalling.\n\nIts combination of a small peptide and copper ion has made it particularly interesting in cosmetic and regenerative research.',
    storage: 'Store lyophilized vials refrigerated. Once reconstituted, keep at 2\u20138 \u00b0C, away from direct light.',
    research: [
      { title: 'Hair Follicle Research', text: 'AHK-Cu has been investigated in laboratory research involving human hair-follicle cells, including pathways associated with follicular growth and cellular activity.' },
      { title: 'Cellular Signalling', text: 'Copper peptides are studied for their interactions with biological pathways involved in cellular communication, extracellular-matrix activity and tissue remodelling.' },
      { title: 'Skin & Matrix Research', text: 'AHK-Cu is also explored in cosmetic research involving skin structure, collagen-associated processes and extracellular-matrix biology.' },
      { title: 'The Copper Connection', text: 'AHK has an affinity for copper ions (Cu\u00b2\u207a). Copper itself is an essential trace element involved in numerous enzymes and biological processes, which is what gives copper-peptide research its distinctive chemistry.' },
      { title: 'AHK-Cu vs GHK-Cu', text: 'They\u2019re both copper-binding tripeptides, but they\u2019re different peptide sequences. GHK-Cu has a much larger published research history, while AHK-Cu is particularly interesting for its research involving hair-follicle biology.' }
    ],
    researchStatus: 'Vial Rat Science \u2014 small peptide, serious copper chemistry. Format: Lyophilized research material.\n\nFOR RESEARCH USE ONLY \u2014 NOT FOR HUMAN OR VETERINARY CONSUMPTION.',
    preorder: true
  },
  {
    slug: 'tirzepatide',
    name: 'Tirzepatide',
    subtitle: 'Active ingredient in Mounjaro\u00ae',
    dose: '10 mg / 30 mg',
    price: 65,
    priceDisplay: '$65.00 \u2013 $140.00',
    stock: 0,
    category: 'Research Peptides',
    image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_lab-rat-study/artifacts/8jfkbxuu_1259DAC2-F11A-4B96-A0BC-0B51C6510AF5.png',
    preorder: true,
    tagline: 'Dual-Pathway Metabolic Research | GIP + GLP-1 Receptor Agonist',
    description: 'Tirzepatide is a synthetic peptide investigated for its effects on metabolic regulation, glucose control, appetite signalling and body weight.\n\nUnlike traditional GLP-1 receptor agonists, tirzepatide activates two incretin pathways \u2014 GIP and GLP-1 \u2014 which is what makes it particularly interesting in metabolic research.',
    storage: 'Store lyophilized vials refrigerated; unopened powder may be frozen for long-term storage. Once reconstituted, keep at 2\u20138 \u00b0C, away from direct light.',
    research: [
      { title: 'Dual Receptor Activity', text: 'Tirzepatide acts as an agonist at both GIP and GLP-1 receptors, two signalling systems involved in metabolism and glucose regulation.' },
      { title: 'Metabolic Research', text: 'Clinical research has demonstrated substantial effects on blood-glucose regulation and metabolic markers in people with type 2 diabetes.' },
      { title: 'Body-Weight Research', text: 'Large randomized clinical trials have found substantial average reductions in body weight during tirzepatide treatment, making weight management one of its most extensively studied applications.' },
      { title: 'Appetite & Satiety', text: 'Its incretin-receptor activity influences pathways involved in appetite, satiety and energy intake.' },
      { title: 'From Research to Medicine', text: 'Tirzepatide itself is no longer merely an experimental molecule: it is the active pharmaceutical ingredient in approved prescription medicines including Mounjaro and Zepbound. Those approvals apply to regulated pharmaceutical products \u2014 not independently manufactured research vials.' }
    ],
    researchStatus: 'Vial Rat Science \u2014 two pathways. One very interesting molecule. Format: Lyophilized research material.\n\nFOR RESEARCH USE ONLY \u2014 NOT FOR HUMAN OR VETERINARY CONSUMPTION.',
    variants: [
      { label: '10 mg', price: 65, priceDisplay: '$65.00', stock: 0, preorder: true },
      { label: '30 mg', price: 140, priceDisplay: '$140.00', stock: 0, preorder: true }
    ]
  },
  {
    slug: 'cagrilintide-10mg',
    name: 'Cagrilintide (Cag)',
    dose: '10 mg',
    price: 95,
    priceDisplay: '$95.00',
    stock: 0,
    category: 'Research Peptides',
    image: 'https://customer-assets-rejwkqb3.emergentagent.net/job_lab-rat-study/artifacts/cke5j7t1_CD81789B-E34A-4E4A-BF66-0FAF8D9D1FE7.png',
    seoTitle: 'Cagrilintide 10 mg Canada | Vial Rat Research Co.',
    tagline: 'Long-Acting Amylin Analogue | Research Use Only',
    description: 'Cagrilintide is a long-acting amylin analogue being investigated for its potential role in appetite regulation, satiety, food intake, and metabolic research. Amylin is a hormone involved in signalling fullness after eating, making the amylin pathway an area of interest in body-weight and metabolic research.\n\nCagrilintide has attracted particular research interest because of its prolonged activity and because it has been studied both independently and in combination with GLP-1-based therapies. Clinical research has included combination studies of cagrilintide with semaglutide, commonly referred to as CagriSema.',
    storage: 'Store lyophilized vials refrigerated. Once reconstituted, keep at 2\u20138 \u00b0C, away from direct light.',
    research: [
      { title: 'Appetite and Satiety Signalling', text: 'Cagrilintide is investigated for its role in appetite and satiety signalling via the amylin pathway.' },
      { title: 'Food-Intake Regulation', text: 'Research explores its effects on food-intake regulation and eating behaviour models.' },
      { title: 'Amylin Receptor Pathways', text: 'Studied for its long-acting activity at amylin and calcitonin-family receptors.' },
      { title: 'Metabolic and Body-Weight Research', text: 'Explored in metabolic research contexts including body-weight regulation.' },
      { title: 'Combination Research', text: 'Investigated in combination with GLP-1-based compounds \u2014 for example, cagrilintide + semaglutide (commonly referred to as CagriSema).' }
    ],
    researchStatus: 'Cagrilintide (Cag) \u2014 10 mg vial. Format: Lyophilized research material.\n\nFOR RESEARCH USE ONLY \u2014 NOT FOR HUMAN OR VETERINARY CONSUMPTION.',
    preorder: true
  }
];

export const heroImage = 'https://static.prod-images.emergentagent.com/jobs/b6d9efba-b5a6-4827-a8fc-40656bb19f7f/images/af73646905a2fe69ee69541615836951a048af7f9144689781766cb4be1cbd27.jpeg';
export const aboutImage = 'https://static.prod-images.emergentagent.com/jobs/b6d9efba-b5a6-4827-a8fc-40656bb19f7f/images/3293fcdfa1abfa66ecc80647e1a65adc0f13fc9c47696571a29eadc31bbbd123.jpeg';
export const faqImage = 'https://static.prod-images.emergentagent.com/jobs/b6d9efba-b5a6-4827-a8fc-40656bb19f7f/images/a21a94544b078fe7ccf2cf9275ab55ed8897a75818c29c128b129c26f7c40a88.jpeg';

export const faqs = [
  {
    q: 'Where do you ship?',
    a: 'We ship exclusively within Canada. All orders are dispatched from within Canada using tracked domestic shipping. International orders are not accepted at this time.'
  },
  {
    q: 'How long does shipping take?',
    a: 'Orders are typically processed within 1-2 business days. Domestic Canadian shipping generally takes 3-7 business days depending on your location. A tracking number is provided as soon as your order ships.'
  },
  {
    q: 'How are orders packaged?',
    a: 'Every order ships in plain, unmarked packaging — no logos, no product information visible from the outside. Vials are cushioned and secured for safe transit.'
  },
  {
    q: 'What payment methods are accepted?',
    a: 'We accept Interac e-Transfer and select cryptocurrency payments. Payment details are provided at checkout. Orders are prepared once payment is confirmed.'
  },
  {
    q: 'How should research products be stored?',
    a: 'Store lyophilized (powdered) vials refrigerated. Unopened powder can be frozen for long-term storage. Once reconstituted, keep vials at 2-8°C (36-46°F), away from direct light, and use within the timeframe recommended for that compound.'
  },
  {
    q: 'How can I contact Vial Rat Research Co.?',
    a: 'Head to our Contact page and open a ticket. We reply to research inquiries within one business day, Monday to Friday.'
  }
];

// Merge extended content from productExtras into the products above.
// Products keep their `placeholder: true` flag so the "COMING SOON" badge stays,
// but overview / description / research / storage content now renders.
products.forEach(p => {
  const extra = productExtras[p.slug];
  if (extra) Object.assign(p, extra);
});

export const supplies = {
  STORAGE: [
    {
      title: 'Peptide Vial Case — 30 Slots (fits 1–3 ml vials)',
      desc: 'Hard-shell fridge and travel case that keeps vials upright, organised and protected from bumps.',
      img: 'https://m.media-amazon.com/images/I/81tRYeH2p5L._AC_SL1500_.jpg',
      url: 'https://amzn.to/4qy3YRq'
    }
  ]
};

export const categories = ['ALL', 'BLENDS', 'RESEARCH COMPOUNDS', 'RESEARCH PEPTIDES'];

// Product-specific extra Amazon supplies (appended to the shared bench supplies on that product page only)
export const productSupplies = {
  'snap-8': [
    {
      title: 'Microneedling Tool \u2014 Skincare Routine Companion',
      desc: 'Popular research pick for microneedling-based skincare routines discussed alongside cosmetic peptide serums.',
      img: 'https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?w=600&q=80',
      url: 'https://amzn.to/4x6OYM7'
    }
  ]
};
